module.exports = __webpack_public_path__ + "media/images/favicon-79a34815f72f3178ef36dfca960c4003.png";